<template>
  <view-page
    :title="pageTitle"
    permission-name="field_management"
    :edit-button="false"
    :delete-button="false"
    :loading="loading"
    :backButton="false"
    class="management background"
  >
    <template v-slot:leftSide>
      <view-page-data-field
        v-for="field in fields"
        :key="field.label"
        :icon="field.icon"
        :label="field.label"
        :data="field.data"
      />
    </template>

    <template v-slot:headerRightSide>
      <management-tabs-and-search
        :tabs="tabs"
        :open-tab="openTab"
        @update-open-tab="openTab = $event"
      />
    </template>

    <template v-slot:rightSide>
      <v-tabs-items :value="openTab">
        <v-tab-item value="description">
          <textarea
            v-model="activity.description"
            id="description"
            class="input-field elevation-1"
            readonly
          />
        </v-tab-item>
        <v-tab-item value="tasks">
          <TasksTable
            :activityUUID="activity.uuid"
            @viewTask="$emit('viewTask', $event)"
          />
        </v-tab-item>
      </v-tabs-items>
    </template>
  </view-page>
</template>

<script>
import { mapActions } from "vuex";
import { activitiesTasksDataMixin } from "@/mixins/field/activitiesTasksDataMixin";
import ViewPage from "@/components/Management/ViewPage/ViewPage";
import ViewPageDataField from "@/components/Management/ViewPage/ViewPageDataField";
import ToggleButtons from "@/components/_Atoms/AppToggleButtons";
import TasksTable from "./TasksListTable.vue";
import ManagementTabsAndSearch from "@/components/_Organisms/ManagementTabsAndSearch";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  name: "NetworkActivityView",

  components: {
    ManagementTabsAndSearch,
    TasksTable,
    ToggleButtons,
    ViewPageDataField,
    ViewPage
  },

  mixins: [activitiesTasksDataMixin, checkPermissionsMixin],

  props: {
    activityUUID: {
      type: String
    }
  },

  data() {
    return {
      activity: {},
      fields: null,
      task: [],

      openTab: "tasks",

      loading: true
    };
  },

  computed: {
    pageTitle() {
      let title = this.$i18n.tc("Activity", 1);
      if (this.activity) {
        if (this.activity.hasOwnProperty("id")) {
          title += " " + this.activity.id;
        }
        if (this.activity.hasOwnProperty("title")) {
          title += ": " + this.activity.title;
        }
      }
      return title;
    },

    tabs() {
      return [
        {
          value: "description",
          text: this.$i18n.t("Description")
        },
        {
          value: "tasks",
          text: this.$i18n.tc("Task", 2),
          disable: !this.userHasFibercloudPermission("field_task", "list")
        }
      ];
    }
  },

  watch: {
    activityUUID(value) {
      if (value) {
        this.getActivity(value);
      }
    }
  },

  methods: {
    ...mapActions(["fetchActivity"]),

    async getActivity(uuid) {
      this.loading = true;
      try {
        this.activity = await this.fetchActivity({
          activityUUID: uuid,
          includes: "fibercloudObject"
        });

        this.fields = this.getFields();
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    getFields() {
      return [
        {
          icon: "label",
          label: this.$i18n.t("Title"),
          data: this.activity.title
        },

        {
          icon: "assignment_turned_in",
          label: this.$i18n.t("State"),
          data: this.getStateLabel(this.activity.state)
        },
        {
          icon: "event",
          label: this.$i18n.t("DueDate"),
          data: this.getFormattedDate(this.activity.due_date)
        },
        /*{
          icon: "link",
          label: this.$i18n.tc("Dependency", 2),
          data: this.showDependencies(this.activity)
        },*/
        {
          icon: "layers",
          label: this.$i18n.tc("Layer", 1),
          data: this.getObjectTypeLabel(this.activity.object_type)
        },
        {
          icon: "home_work",
          label: this.$i18n.tc("Object", 1),
          data: this.activity.object ? this.activity.object.label : null
        },
        {
          icon: "person",
          label: this.$i18n.tc("Creator", 1),
          data: this.getUserName(this.activity.user_creator_id)
        }
      ];
    }
  }
};
</script>

<style scoped>
.background {
  background-color: #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Activities/ActivityView.vue